var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatasources2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#4C5664",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.25 4.125c0 1.03575-2.3505 1.875-5.25 1.875s-5.25-.83925-5.25-1.875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.25 7.125c0 1.03575-2.3505 1.875-5.25 1.875s-5.25-.83925-5.25-1.875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.25 10.125c0 1.0358-2.3505 1.875-5.25 1.875s-5.25-.8392-5.25-1.875v-6c0-1.03575 2.3505-1.875 5.25-1.875s5.25.83925 5.25 1.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 12v1.875"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m10.125 15h4.875",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 15h4.875",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.7955 14.2045c.4393.4393.4393 1.1517 0 1.591-.43934.4393-1.15165.4393-1.591 0-.43933-.4393-.43933-1.1517 0-1.591.43934-.4393 1.15165-.4393 1.591 0z",
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasources2);
export default __webpack_public_path__ + "static/media/datasources-2.c74a9468406106f6fef48127de43266b.svg";
export { ForwardRef as ReactComponent };